/**
 * Public contract of the player wrapper.
 *
 * The wrapper is a headless controller: it owns HLS playlist munging (angle
 * extraction, quality capping, key handling, decryption), playback policy
 * (recovery, coming-soon polling) and a framework-free state
 * store. It drives an engine through the {@link PlayerAdapter} interface —
 * video.js (VHS) on the web today, AVPlayer / ExoPlayer in a Capacitor shell
 * later.
 *
 * Implementing projects (the media encoder app, the Luminary app, …) talk to
 * {@link PlayerController} only; they never touch the adapter or the engine.
 */
export const DEFAULT_RECOVERY_POLICY = {
    escalationWindowMs: 10_000,
    maxReloadAttempts: 3,
    reloadDelaysMs: [2_000, 4_000, 8_000],
};
/** Fill a caller's partial overrides out to a complete policy. */
export function resolveRecoveryPolicy(overrides) {
    return { ...DEFAULT_RECOVERY_POLICY, ...overrides };
}
/**
 * Pseudo-angle id for the audio-only rendering synthesized from the master's
 * audio groups. Selecting it plays a munged master with ZERO video variants —
 * no video data is downloaded at all (restricted-bandwidth use case).
 */
export const AUDIO_ONLY_ANGLE_ID = '__audio__';
/** What a data saver starts the adaptive logic from, in bits per second: the lowest rungs. */
export const DATA_SAVER_START_BPS = 1_000_000;
//# sourceMappingURL=types.js.map